import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateInboundWhatsAppRules as UpdateInboundWhatsAppRulesMutation,
    UpdateInboundWhatsAppRulesVariables as UpdateInboundWhatsAppRulesMutationVariables,
    InboundWhatsAppRulesUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_INBOUND_WHATSAPP_RULES from '../mutations/update-inbound-whatsapp-rules.graphql';

export const useUpdateInboundWhatsAppRules = (): {
    updateInboundWhatsAppRules: (input: InboundWhatsAppRulesUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateInboundWhatsAppRules, {loading, error}] = useMutation<
        UpdateInboundWhatsAppRulesMutation,
        UpdateInboundWhatsAppRulesMutationVariables
    >(UPDATE_INBOUND_WHATSAPP_RULES);

    return {
        updateInboundWhatsAppRules: (input: InboundWhatsAppRulesUpdateInput) => {
            return updateInboundWhatsAppRules({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
